export function initIntersectionAnimate() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        entry.target.classList.add("intersect-animate")
        observer.unobserve(entry.target)
      }
    })
  })
  const animatedElements = document.querySelectorAll(".section > *")
  for (const element of animatedElements) {
    observer.observe(element)
  }
}
